import React from 'react'
import HuubleCard from './HuubleCard'
import HubbleScoreListElement from './HubbleScoreListElement'
import classes from '../styles/style.module.css'

const HubbleScoreList = () => {
    return (
        <HuubleCard>
            <div className={classes.ratesContainer}>
                <HubbleScoreListElement />
                <HubbleScoreListElement />
                <HubbleScoreListElement />
            </div>
        </HuubleCard>
    )
}

export default HubbleScoreList